import styled, { css } from 'styled-components';

export const Button = styled.a<{ $style: 'default' | 'outline' | 'outline-reverted' }>`
    text-decoration: none;
    font-size: 16px;
    padding: 10px 30px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-block;
    text-align: center;
    align-items: center;
    font-weight: 500;
    display: flex;
    postion: relative;
    text-align: center;
    justify-content: center;

    @media (max-width: 600px) {
        width: 100%;
    }

    @media (min-width: 979px) and (max-width: 1200px) {
        padding: 10px;
    }

    ${props =>
        props.$style === 'default' &&
        css`
            color: white;
            background-color: black;
            border: 2px solid black;

            svg {
                fill: white;
                margin: 0 !important;
                margin-left: 10px !important;
            }

            &:hover {
                background-color: rgba(11, 113, 83, 0.5);
                border-color: transparent;
                color: white;

                svg {
                    fill: white;
                    margin: 0 !important;
                    margin-left: 10px !important;
                }
            }
        `}

    ${props =>
        props.$style === 'outline' &&
        css`
            color: black;
            background-color: transparent;
            border: 2px solid black;

            svg {
                fill: #171717;
                margin: 0 !important;
                margin-left: 10px !important;
            }

            &:hover {
                background-color: rgba(11, 113, 83, 0.5);
                border-color: transparent;
                color: white;

                svg {
                    fill: white;
                    margin: 0 !important;
                    margin-left: 10px !important;
                }
            }
        `}

  ${props =>
        props.$style === 'outline-reverted' &&
        css`
            color: white;
            background-color: transparent;
            border: 2px solid white;
            svg {
                fill: white;
                margin: 0 !important;
                margin-left: 10px !important;
            }
            &:hover {
                background-color: white;
                border-color: white;
                color: black;
                svg {
                    fill: black;
                }
            }
        `}

    @media (max-width: 600px) {
        text-align: center;
    }
`;
